import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BehavioralRangesRectanglesModule } from '../../core-ui/BehavioralRangesRectangles/BehavioralRangesRectangles.module';
import { TranslationsModule } from '../../translations/translations.module';
import { BehavioralPatternImageComponent } from './BehavioralPatternImage.component';
import { BehavioralPatternImageWrapperComponent } from './BehavioralPatternImageWrapper.component';

export const BehavioralPatternImageModuleExports = [
    BehavioralPatternImageComponent,
    BehavioralPatternImageWrapperComponent
];

@NgModule({
    declarations: [...BehavioralPatternImageModuleExports],
    exports: [...BehavioralPatternImageModuleExports],
    providers: [],
    imports: [
        CommonModule,
        BehavioralRangesRectanglesModule,
        TranslationsModule
    ]
})
export class BehavioralPatternImageModule {}
